/**
 * Copy for the LAST-RESORT React error boundary -- the one wrapping a whole app root rather than a feature.
 *
 * WHY IT IS ITS OWN LEAF. Two roots read it and they are in different layers: `StandaloneSpaProviders`
 * (every `spa/*` standalone entry) and `createMFEMount` (every embedded MFE bundle). Before 2026-08-20 NEITHER had a
 * boundary at all -- 0 of the 7 SPA roots -- so any uncaught render error unwound the root and left the viewer a WHITE
 * PAGE with the error visible only in the console.
 *
 * The wording assumes nothing about the surface, because a root boundary cannot: it names the recoverable action and
 * stops. The retry VERB is not respelled here -- `ERROR_ACTION_LABELS.tryAgain` (`components/error/errorLabels.ts`)
 * already owns it for every error surface.
 */

export const ROOT_ERROR_BOUNDARY_COPY = {
	title: 'Something went wrong',
	body: 'This page hit an unexpected error and stopped. Reloading it usually clears the problem; if it does not, try again in a moment.',
} as const;
